import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import {store,persistor} from './ReduxState/Store.js';
import { HashRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react'
import { loadConfig } from './config.js';


ReactDOM.render(
  <Provider store={store}>
  <HashRouter basename="">
  <PersistGate loading={null} persistor={persistor}>
    < App/>
    </PersistGate>
  </HashRouter>
  </Provider >
 ,document.getElementById('root')
);

// loadConfig().then(() => {
//   ReactDOM.render(
//     <Provider store={store}>
//     <HashRouter basename="">
//     <PersistGate loading={null} persistor={persistor}>
//       < App/>
//       </PersistGate>
//     </HashRouter>
//     </Provider >
//    ,document.getElementById('root')
//   );
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
